export default class Home {
  constructor() {
    // http://stackoverflow.com/questions/7131909/facebook-callback-appends-to-return-url
    if (window.location.hash === "#_=_") {
      if (history.replaceState) {
        history.replaceState(null, null, window.location.href.split("#")[0]);
      } else {
        window.location.hash = "";
      }
    }
  }
}
